@if (feldBeschreibung | async; as item) {
  <h3>
    {{ item?.title }}
    @if (showInfo && item?.hilfetext) {
      <mat-icon
        svgIcon="innogy_picto_speech-bubble_exclamationmark"
        [matTooltip]="item?.hilfetext"
        matTooltipPosition="right"
        matTooltipClass="multiline-tooltip"
        aria-hidden="false"
        aria-label="Info: {{ item?.hilfetext }}"
      >
      </mat-icon>
    }
  </h3>
}
